import { Spin } from 'antd'
import React from 'react'

import FullscreenLayout from 'common/layouts/fullscreen'

function LoadingFallback() {
  return (
    <FullscreenLayout
      render={({ Content }) => (
        <Content>
          <Spin />
        </Content>
      )}
    />
  )
}

export default LoadingFallback
